import Layout from '@/views/Layout';

// 产品报表

export default {
  name: 'ProductReport',
  path: '/product-report',
  meta: {
    icon: 'el-icon-document',
    label: '产品报表',
    isMenu: true,
  },
  component: Layout,
  children: [],
};
